// import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { doc, getDoc } from 'firebase/firestore';
// import { db } from '../firebase';  // Import your Firestore configuration
// import { toast } from 'react-toastify';

// const ViewRetakeTrainingResult = () => {
//     const { userId, trainingId } = useParams();  // Extract userId and trainingId from URL params
//     const [retakes, setRetakes] = useState([]);
//     const [loading, setLoading] = useState(true);

//     // Fetch retake data from Firestore
//     useEffect(() => {
//         const getRetakes = async () => {
//             try {
//                 const retakeDocRef = doc(
//                     db,
//                     "users",
//                     userId,
//                     "quizzes",
//                     trainingId,
//                     "retakes",
//                     trainingId
//                 );

//                 // Get the retakes document for the specific user and training
//                 const retakesSnap = await getDoc(retakeDocRef);

//                 if (retakesSnap.exists()) {
//                     // If retakes data exists, set it to the state
//                     const retakesData = retakesSnap.data().attempts || [];
//                     setRetakes(retakesData);
//                     setLoading(false);
//                 } else {
//                     toast.info("No retakes found for this quiz.");
//                     setLoading(false);
//                 }
//             } catch (error) {
//                 toast.error("Error fetching retakes: " + error.message);
//                 setLoading(false);
//             }
//         };

//         getRetakes(); // Fetch retakes when the component mounts
//     }, [userId, trainingId]);

//     // Download function for retakes data as JSON
//     const handleDownload = () => {
//         const retakesData = JSON.stringify(retakes, null, 2);
//         const blob = new Blob([retakesData], { type: 'application/json' });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = `retakes-${userId}-${trainingId}.json`;
//         a.click();
//         URL.revokeObjectURL(url);
//     };

//     return (
//         <div>
//             <h3>Retake Results for Training: {trainingId}</h3>

//             {loading ? (
//                 <p>Loading...</p>
//             ) : (
//                 <div>
//                     {retakes.length > 0 ? (
//                         <div>
//                             <table className="table table-striped">
//                                 <thead>
//                                     <tr>
//                                         <th>#</th>
//                                         <th>Score</th>
//                                         <th>Completed At</th>
//                                         <th>Download</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {retakes.map((retake, index) => (
//                                         <tr key={index}>
//                                             <td>{index + 1}</td>
//                                             <td>{retake.score}</td>
//                                             <td>{retake.completedAt}</td>
//                                             <td>
//                                                 <button 
//                                                     className="btn btn-outline-primary btn-sm"
//                                                     onClick={() => handleDownload()} 
//                                                 >
//                                                     Download Retake {index + 1}
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>

//                             <button onClick={handleDownload} className="btn btn-primary">
//                                 Download All Retakes Data
//                             </button>
//                         </div>
//                     ) : (
//                         <p>No retakes available.</p>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ViewRetakeTrainingResult;












// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../firebase"; // Import your Firestore configuration
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewRetakeTrainingResult = () => {
//   const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
//   const [retakes, setRetakes] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch retake data from Firestore
//   useEffect(() => {
//     const getRetakes = async () => {
//       try {
//         // Reference to the retakes subcollection
//         const retakesCollectionRef = collection(
//           db,
//           "users",
//           userId,
//           "quizzes",
//           trainingId,
//           "retakes"
//         );

//         // Fetch all documents in the retakes subcollection
//         const retakesSnapshot = await getDocs(retakesCollectionRef);

//         if (!retakesSnapshot.empty) {
//           // Map through the documents and extract the attempts array
//           const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
//           console.log("Retakes Data:", retakesData); // Log the retakes data
//           setRetakes(retakesData.flat()); // Flatten the array of attempts
//         } else {
//           toast.info("No retakes found for this quiz.");
//         }
//       } catch (error) {
//         toast.error("Error fetching retakes: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getRetakes();
//   }, [userId, trainingId]);

//   return (
//     <div className="container mt-3" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
//       <h3>Retake Results for Training: {trainingId}</h3>

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <div>
//           {retakes.length > 0 ? (
//             retakes.map((retake, retakeIndex) => (
//               <div key={retakeIndex} className="mb-5">
//                 <h4>Retake {retakeIndex + 1}</h4>
//                 <p><strong>Score:</strong> {retake.score}</p>
//                 <p><strong>Completed At:</strong> {retake.completedAt}</p>

//                 <table className="table table-bordered">
//                   <thead>
//                     <tr>
//                       <th>Question</th>
//                       <th>Your Answer</th>
//                       <th>Correct Answer</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {Array.isArray(retake.answers) && retake.answers.length > 0 ? (
//                       retake.answers.map((answer, index) => (
//                         <tr key={index}>
//                           <td>{answer.questionText}</td>
//                           <td
//                             style={{
//                               color: answer.userAnswer === answer.correctAnswer ? "green" : "red",
//                             }}
//                           >
//                             {answer.userAnswer}
//                           </td>
//                           <td>{answer.correctAnswer}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="3">No answers found for this retake.</td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             ))
//           ) : (
//             <p>No retakes available.</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ViewRetakeTrainingResult;























import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firestore configuration
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ViewRetakeTrainingResult = () => {
  const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
  const [retakes, setRetakes] = useState([]); // User's retake attempts
  const [questions, setQuestions] = useState([]); // Questions from trainings collection
  const [loading, setLoading] = useState(true);

  // Fetch retake data from Firestore
  useEffect(() => {
    const getRetakesAndQuestions = async () => {
      try {
        // Fetch retakes from users collection
        const retakesCollectionRef = collection(
          db,
          "users",
          userId,
          "quizzes",
          trainingId,
          "retakes"
        );
        const retakesSnapshot = await getDocs(retakesCollectionRef);

        // Fetch questions from trainings collection
        const questionsCollectionRef = collection(db, `trainings/${trainingId}/questions`);
        const questionsSnapshot = await getDocs(questionsCollectionRef);

        if (!retakesSnapshot.empty && !questionsSnapshot.empty) {
          // Extract retakes data
          const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
          setRetakes(retakesData.flat()); // Flatten the array of attempts

          // Extract questions data
          const questionsData = questionsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setQuestions(questionsData);
        } else {
          toast.info("No retakes or questions found for this quiz.");
        }
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    getRetakesAndQuestions();
  }, [userId, trainingId]);

  // Helper function to get the user's answer for a specific question index
  const getUserAnswer = (retake, index) => {
    if (!Array.isArray(retake.answers)) {
      return "Not answered"; // If answers is not an array
    }
    if (retake.answers[index] && retake.answers[index].id !== undefined) {
      return retake.answers[index].id ? "True" : "False"; // Convert boolean to "True" or "False"
    }
    return "Not answered"; // If no answer found for this question
  };

  return (
    <div className="container mt-3" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
      <h3>Retake Results for Training: {trainingId}</h3>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          {retakes.length > 0 ? (
            retakes.map((retake, retakeIndex) => (
              <div key={retakeIndex} className="mb-5">
                <h4>Retake {retakeIndex + 1}</h4>
                <p><strong>Score:</strong> {retake.score}</p>
                <p><strong>Completed At:</strong> {retake.completedAt}</p>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Your Answer</th>
                      <th>Correct Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {questions.map((question, index) => {
                      const userAnswer = getUserAnswer(retake, index); // Get user's answer
                      const correctAnswer = question.answer ? "True" : "False"; // Convert correct answer to "True" or "False"

                      return (
                        <tr key={index}>
                          <td>{question.text}</td> {/* Render question text */}
                          <td
                            style={{
                              color: userAnswer === correctAnswer ? "green" : "red",
                            }}
                          >
                            {userAnswer}
                            {console.log(retake)}
                          </td> {/* Render user's answer */}
                          <td>{correctAnswer}</td> {/* Render correct answer */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <p>No retakes available.</p>
          )}
        </div>
      )}
    </div>

    
  );
};

export default ViewRetakeTrainingResult;